import React, { useCallback, useEffect, useMemo } from 'react';
import OrdersApi from '../OrdersApi';

import FieldSelect from '@dex/bubl-dash/src/lib/components/Fields/FieldSelect';
import { Form, useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import Sort from '@dex/bubl-dash/src/lib/components/Sort/Sort';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Box } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Loading from '@dex/bubl-dash/src/lib/components/Loading/Loading';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';

const OrdersSort: React.FC<any> = (props: any) => {

    const app = useApp();

    const form = useForm({ section: "other" });

    const Orders = OrdersApi.get();

    const save = OrdersApi.create({}, "reOrders");

    useEffect(() => {

        const params: any = { where: {}, include: [], Orders: ["Orders ASC"], limit: 1000 };

        Orders.reset();
        Orders.cancel();

        Orders.run({
            params: params
        });

    }, [form.values.section]);

    const handleSave = useCallback((data) => {

        save.run({
            data: { rows: data },
            onComplete: (response: any) => {

                app.alert(response, 'success');

            }
        });

    }, []);

    return useMemo(() => (

        <Box gutter={"auto"}>

            <Panel
                heading={"Re-Orders"}
            >

                {Orders.loading &&
                    <Box gutter={"auto"}>
                        <br />
                        <Loading />
                    </Box>
                }

                {Orders.data && Orders.data.data && Orders.data.data.length > 0 &&

                    <Sort
                        data={Orders.data.data}
                        // parentIdKey={"parentId"}
                        preSorted={true}
                        maxDepth={1}
                        handleSave={handleSave}
                        loading={save.loading}
                    />

                }

            </Panel>

        </Box>

    ), [form.values, Orders.loading, save.loading]);

}

export default OrdersSort;
